import { useAuthState } from '@spa/scenes/Auth/shared/services'

import { trackSignupProcessEvent } from '../events'
import type { ActionName } from '../types'

export type SignupProcessData = {
  actionName: ActionName
  email: string
  firstName?: string
  lastName?: string
  companyName?: string
  jobTitle?: string
  phone?: {
    countryCode: string
    number: string
  }
}

export const useTrackSignupProcess = () => {
  const { auth } = useAuthState()

  const trackSubmitClicked = (signupProcessData: SignupProcessData) => {
    const properties = {
      account_id: auth.accountId as number,
      action_name: signupProcessData.actionName,
      first_name: signupProcessData.firstName,
      last_name: signupProcessData.lastName,
      company_name: signupProcessData.companyName,
      job_title: signupProcessData.jobTitle,
      phone: signupProcessData.phone,
      email: signupProcessData.email
    }

    trackSignupProcessEvent(properties, auth.userId as number)
  }

  return {
    trackSubmitClicked
  }
}
